import React from 'react'
import { formatDateTime } from 'utils/functions'

import Colors from 'utils/Colors'
import Container from './styles'

function DisplayJustificative(props) {
  const { reviewer, reviewerComment, status, isWaitingClarification, decisionTimestamp, waitingClarificationTimestamp } = props
  const actions = {
    APPROVED: 'Aprovado',
    REPROVED: 'Reprovado',
    WAITING_DECISION: 'Analisado',
  }

  return (
    <Container>
      {isWaitingClarification && (
        <p>
          <h4 style={{ color: Colors.blue }}>O caso está aguardando esclarecimentos</h4>
        </p>
      )}
      <p>
        <span>{`${actions[status]} por: `}</span>
        {reviewer}
      </p>
      {decisionTimestamp && (
        <p>
          <span>{`Data/Hora: `}</span>
          {formatDateTime(decisionTimestamp)}
        </p>
      )}
      {(isWaitingClarification && waitingClarificationTimestamp) && (
        <p>
          <span>{`Data/Hora: `}</span>
          {formatDateTime(waitingClarificationTimestamp)}
        </p>
      )}
      {reviewerComment && (
        <p>
          <span>{`Comentário do revisor: `}</span>
          {reviewerComment}
        </p>
      )}
    </Container>
  )
}

export default DisplayJustificative
